module.exports = __webpack_public_path__ + "static/media/alexei-maridashvili-4f3VU5uhOEA-unsplash.32d5e48a.jpg";